import { render } from "./ClockUpdate.vue?vue&type=template&id=5235554a&scoped=true"
import script from "./ClockUpdate.vue?vue&type=script&lang=js"
export * from "./ClockUpdate.vue?vue&type=script&lang=js"

import "./ClockUpdate.vue?vue&type=style&index=0&id=5235554a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5235554a"]])

export default __exports__